import * as Scrivito from 'scrivito';
import { LinkWidgetAttributes, LinkWidgetId } from './link-widget-definitions';

export const LinkWidgetClass = Scrivito.provideWidgetClass(LinkWidgetId, {
  attributes: {
    [LinkWidgetAttributes.TITLE]: 'string',
    [LinkWidgetAttributes.LINK]: 'link',
    [LinkWidgetAttributes.ACCESSIBILITY_TEXT]: 'string',
  },
});

export type LinkWidget = InstanceType<typeof LinkWidgetClass>;
